import React from 'react';
import '../assets/css/style.css';
import { Button } from 'react-bootstrap';
import BottomCard from './count';
import image from "../assets/css/img/TATA.png";
import backgroundVideo from "../assets/css/img/home.MP4"

const Home = () => {
  return (
    <div className="home-page mb-0" id="home">
      {/* Background image */}
      <div className="background-video">
        <video autoPlay loop muted playsInline className="video-bg">
          <source src={backgroundVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className='d-flex flex-column align-items-end tata'>
        <img className='tata-img' src={image} />
        <span><p style={{ color: "#fff", marginTop: "-20px" }}>Trusted partner</p></span>
      </div>

      {/* Overlay with text */}
      <div className="overlay">
        <h1 >Empowering India’s
          Future Through Cutting-
          Edge Solar Solutions</h1>
        <p>
          "At Axis Solar Systems,
          we are dedicated to
          delivering sustainable
          solar energy solutions
          across residential,
          commercial, and
          industrial sectors. As an
          Authorized Channel
          Partner of Tata Power
          Solar, India’s No.1 solar
          company, we bring
          industry-leading expertise
          and reliability to every
          project".

        </p>
        {/* <button className="contact-button active">
          <a href="#Contact" style={{ color: "#fff", textDecoration: "none" }}>Know more</a>
        </button> */}
      </div>

      <BottomCard />
    </div>
  );
};

export default Home;


